export default __webpack_public_path__ + "static/media/find_ideal_bg.55199fa3.png";